import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomPaginator extends MatPaginatorIntl {
	private translocoService = inject(TranslocoService);

	constructor() {
		super();

		this.translocoService.langChanges$.subscribe(() => {
			this.getAndInitTranslations();
		});

		this.getAndInitTranslations();
	}

	getAndInitTranslations = () => {
		this.itemsPerPageLabel = this.translocoService.translate('araPaginator.itemsPerPage');
		this.nextPageLabel = this.translocoService.translate('araPaginator.nextPage');
		this.previousPageLabel = this.translocoService.translate('araPaginator.previousPage');
		this.firstPageLabel = this.translocoService.translate('araPaginator.firstPage');
		this.lastPageLabel = this.translocoService.translate('araPaginator.lastPage');
		this.getRangeLabel = this.getRangeLabel.bind(this);
		this.changes.next();
	};

	override getRangeLabel = (page: number, pageSize: number, length: number): string => {
		if (length === 0 || pageSize === 0) {
			return this.translocoService.translate('araPaginator.rangeLabelZero', { length });
		}

		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

		return this.translocoService.translate('araPaginator.rangeLabel', {
			startIndex: startIndex + 1,
			endIndex,
			length,
		});
	};
}
